import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/lib/LanguageContext";
import GoogleLoginButton from "@/lib/GoogleLoginButton";

export default function SuperAdminLogin() {
  const navigate = useNavigate();
  const t = useT("superadmin");

  useEffect(() => {
    api
      .get("/super-admin/me")
      .then((r) => {
        if (r.data?.is_super_admin) navigate("/super-admin", { replace: true });
      })
      .catch(() => {});
  }, [navigate]);

  const handleSignedIn = () => {
    // SuperAdminLayout revérifie /super-admin/me et renvoie vers /super-admin/login
    // si le compte n'est pas super-admin ; ici on navigue simplement vers la zone.
    navigate("/super-admin", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#f7f8f9] text-slate-800 flex items-center justify-center p-6 relative overflow-hidden">
      {/* Sunset glow */}
      <div className="pointer-events-none absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full opacity-30 blur-[120px]"
           style={{ background: "radial-gradient(circle, #E6B85C 0%, #d97757 40%, transparent 70%)" }} />
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-3xl p-12 text-center relative z-10 backdrop-blur-sm" data-testid="sa-login-card">
        <img src="/brand/solunary-logo.png" alt="Solunary" className="w-16 h-16 mx-auto mb-2 object-contain" onError={(e) => { e.target.style.display = "none"; }} />
        <div className="font-sans font-bold text-3xl tracking-wide text-slate-900 mb-1">Solunary</div>
        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-500 mb-8">{t("sa.login.console")}</div>
        <div data-testid="sa-google-signin" className="flex justify-center">
          <GoogleLoginButton onSuccess={handleSignedIn} />
        </div>
        {/* No allowlist here: access comes from the server's configuration (SUPER_ADMIN_EMAILS,
            SUPER_ADMIN_DOMAINS, Team grants), and naming it would tell an anonymous visitor
            which addresses to aim for. Platform Settings shows the domains to super admins. */}
        <p className="mt-8 text-xs text-slate-500 font-medium" data-testid="sa-login-restricted">
          {t("sa.login.restricted")}
        </p>
      </div>
    </div>
  );
}
